import { render, staticRenderFns } from "./projectPortrait.vue?vue&type=template&id=24bf56d5&"
import script from "./projectPortrait.vue?vue&type=script&lang=js&"
export * from "./projectPortrait.vue?vue&type=script&lang=js&"
import style0 from "./projectPortrait.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports